var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleEn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_746",
    "data-name": "Group 746",
    xmlns: "http://www.w3.org/2000/svg",
    width: 191,
    height: 63.845,
    viewBox: "0 0 191 63.845",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_743",
    "data-name": "Group 743"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_738",
    "data-name": "Group 738"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_737",
    "data-name": "Group 737"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_752",
    "data-name": "Path 752",
    d: "M175.79,0H15.219c-.586,0-1.164,0-1.748,0-.488,0-.974.013-1.467.021A21,21,0,0,0,8.806.3a10.726,10.726,0,0,0-3.034,1A10.286,10.286,0,0,0,3.189,3.187,10.031,10.031,0,0,0,1.307,5.775a10.574,10.574,0,0,0-1,3.037,20.874,20.874,0,0,0-.286,3.2c-.014.49-.016.982-.024,1.47V50.372c.008.495.01.975.024,1.47a20.838,20.838,0,0,0,.286,3.2,10.546,10.546,0,0,0,1,3.041,9.948,9.948,0,0,0,1.882,2.576,10.055,10.055,0,0,0,2.583,1.882,10.686,10.686,0,0,0,3.034,1.006,21.206,21.206,0,0,0,3.2.283c.493.011.978.018,1.467.018.584,0,1.162,0,1.748,0H175.79c.573,0,1.156,0,1.73,0,.485,0,.985-.006,1.472-.018a20.942,20.942,0,0,0,3.192-.283,10.824,10.824,0,0,0,3.045-1.006,10.074,10.074,0,0,0,2.581-1.882,10.231,10.231,0,0,0,1.887-2.576,10.576,10.576,0,0,0,.988-3.041,21.472,21.472,0,0,0,.3-3.2c.006-.495.006-.975.006-1.47.013-.581.013-1.157.013-1.746V15.221c0-.584,0-1.164-.013-1.743,0-.488,0-.98-.006-1.47a21.512,21.512,0,0,0-.3-3.2,10.6,10.6,0,0,0-.988-3.037,10.333,10.333,0,0,0-4.468-4.469,10.864,10.864,0,0,0-3.045-1,20.739,20.739,0,0,0-3.192-.281c-.487-.008-.986-.018-1.472-.021-.575,0-1.157,0-1.73,0Z",
    fill: "#a2a2a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_753",
    "data-name": "Path 753",
    d: "M12.959,61.927c-.487,0-.961-.006-1.443-.018a20.142,20.142,0,0,1-2.985-.26,9.361,9.361,0,0,1-2.643-.875,8.577,8.577,0,0,1-2.23-1.622,8.506,8.506,0,0,1-1.63-2.23,9.181,9.181,0,0,1-.867-2.645A19.772,19.772,0,0,1,.9,51.286c-.011-.337-.024-1.457-.024-1.457V12.956s.014-1.1.024-1.427A19.712,19.712,0,0,1,1.16,8.541a9.138,9.138,0,0,1,.868-2.653,8.52,8.52,0,0,1,1.62-2.231A8.887,8.887,0,0,1,5.886,2.024a9.287,9.287,0,0,1,2.638-.868A20.191,20.191,0,0,1,11.519.894l1.44-.019H176.992L178.449.9a19.727,19.727,0,0,1,2.966.259,9.5,9.5,0,0,1,2.667.875,8.927,8.927,0,0,1,3.855,3.863,9.159,9.159,0,0,1,.854,2.632,20.461,20.461,0,0,1,.278,3.012c0,.452,0,.939,0,1.421.013.6.013,1.168.013,1.743V48.1c0,.579,0,1.146-.013,1.716,0,.519,0,.994-.006,1.484a20.04,20.04,0,0,1-.273,2.958,9.131,9.131,0,0,1-.862,2.666,8.738,8.738,0,0,1-1.62,2.212,8.6,8.6,0,0,1-2.235,1.631,9.308,9.308,0,0,1-2.662.878,19.888,19.888,0,0,1-2.983.26c-.468.011-.956.018-1.432.018l-1.73,0Z",
    transform: "translate(0.52 0.522)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_742",
    "data-name": "Group 742",
    transform: "translate(15.916 13.918)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_740",
    "data-name": "Group 740"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_739",
    "data-name": "Group 739"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_754",
    "data-name": "Path 754",
    d: "M33.59,24.073a7.9,7.9,0,0,1,3.76-6.627A8.081,8.081,0,0,0,30.98,14c-2.68-.281-5.278,1.6-6.645,1.6-1.392,0-3.494-1.577-5.759-1.529a8.482,8.482,0,0,0-7.14,4.353c-3.087,5.345-.784,13.2,2.172,17.521,1.48,2.115,3.208,4.477,5.472,4.394,2.214-.093,3.041-1.413,5.713-1.413,2.648,0,3.424,1.413,5.732,1.36,2.377-.04,3.872-2.126,5.3-4.262a17.486,17.486,0,0,0,2.423-4.935A7.631,7.631,0,0,1,33.59,24.073Z",
    transform: "translate(-9.972 -5.588)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_755",
    "data-name": "Path 755",
    d: "M23.982,14.292a7.78,7.78,0,0,0,1.78-5.572,7.916,7.916,0,0,0-5.12,2.65,7.4,7.4,0,0,0-1.826,5.365A6.544,6.544,0,0,0,23.982,14.292Z",
    transform: "translate(-4.724 -8.72)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_741",
    "data-name": "Group 741",
    transform: "translate(39.034 14.606)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_756",
    "data-name": "Path 756",
    d: "M47,32.542H39.442L37.627,37.9h-3.2l7.157-19.821h3.325L52.064,37.9H48.81ZM40.224,30.07h5.989L43.26,21.376h-.081Z",
    transform: "translate(-34.427 -17.748)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_757",
    "data-name": "Path 757",
    d: "M60.244,28.725c0,4.49-2.4,7.376-6.032,7.376a4.9,4.9,0,0,1-4.546-2.528H49.6V40.73H46.631V21.5H49.5v2.4h.054a5.13,5.13,0,0,1,4.6-2.554C57.826,21.348,60.244,24.247,60.244,28.725Zm-3.049,0c0-2.926-1.513-4.849-3.82-4.849-2.267,0-3.791,1.963-3.791,4.849,0,2.911,1.524,4.862,3.791,4.862C55.683,33.587,57.2,31.677,57.2,28.725Z",
    transform: "translate(-27.152 -15.798)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_758",
    "data-name": "Path 758",
    d: "M70.209,28.725c0,4.49-2.4,7.376-6.032,7.376a4.9,4.9,0,0,1-4.546-2.528h-.069V40.73H56.6V21.5h2.871v2.4h.054a5.128,5.128,0,0,1,4.6-2.554C67.791,21.348,70.209,24.247,70.209,28.725Zm-3.05,0c0-2.926-1.512-4.849-3.818-4.849-2.267,0-3.791,1.963-3.791,4.849,0,2.911,1.524,4.862,3.791,4.862C65.648,33.587,67.159,31.677,67.159,28.725Z",
    transform: "translate(-21.211 -15.798)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_759",
    "data-name": "Path 759",
    d: "M72.844,32.5c.22,1.966,2.129,3.256,4.739,3.256,2.5,0,4.3-1.29,4.3-3.063,0-1.539-1.085-2.46-3.654-3.09l-2.57-.619C72.02,28.1,70.33,26.4,70.33,23.639c0-3.419,2.98-5.768,7.213-5.768,4.188,0,7.06,2.35,7.155,5.768H81.7c-.179-1.978-1.813-3.172-4.2-3.172s-4.024,1.208-4.024,2.966c0,1.4,1.044,2.227,3.6,2.857l2.184.536c4.067.962,5.756,2.6,5.756,5.5,0,3.708-2.953,6.03-7.65,6.03-4.4,0-7.365-2.268-7.556-5.853Z",
    transform: "translate(-13.335 -17.871)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_760",
    "data-name": "Path 760",
    d: "M85.243,19.3v3.419h2.749v2.35H85.243v7.966c0,1.239.551,1.815,1.759,1.815a9.1,9.1,0,0,0,.975-.069v2.335a8.113,8.113,0,0,1-1.647.137c-2.926,0-4.067-1.1-4.067-3.9V25.068h-2.1v-2.35h2.1V19.3Z",
    transform: "translate(-7.162 -17.019)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_761",
    "data-name": "Path 761",
    d: "M86.065,28.735c0-4.547,2.678-7.4,6.854-7.4s6.855,2.857,6.855,7.4-2.651,7.4-6.855,7.4S86.065,33.294,86.065,28.735Zm10.686,0c0-3.119-1.429-4.961-3.832-4.961s-3.831,1.855-3.831,4.961c0,3.132,1.427,4.958,3.831,4.958S96.751,31.867,96.751,28.735Z",
    transform: "translate(-3.644 -15.808)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_762",
    "data-name": "Path 762",
    d: "M96.186,21.5h2.83v2.46h.067a3.448,3.448,0,0,1,3.476-2.61,4.6,4.6,0,0,1,1.017.11v2.774a4.181,4.181,0,0,0-1.333-.179,2.99,2.99,0,0,0-3.092,3.325v8.571H96.186Z",
    transform: "translate(2.39 -15.798)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_763",
    "data-name": "Path 763",
    d: "M114.253,31.715c-.4,2.622-2.953,4.423-6.222,4.423-4.2,0-6.814-2.816-6.814-7.334s2.624-7.473,6.689-7.473c4,0,6.512,2.747,6.512,7.128v1.017H104.211v.179a3.763,3.763,0,0,0,3.888,4.092,3.27,3.27,0,0,0,3.338-2.032ZM104.226,27.4h7.224a3.474,3.474,0,0,0-3.543-3.668A3.66,3.66,0,0,0,104.226,27.4Z",
    transform: "translate(5.389 -15.808)",
    fill: "#fff"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_745",
    "data-name": "Group 745",
    transform: "translate(56.936 13.467)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_744",
    "data-name": "Group 744"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_764",
    "data-name": "Path 764",
    d: "M39.111,8.731c2.825,0,4.482,1.735,4.482,4.733,0,3.042-1.644,4.792-4.482,4.792h-3.44V8.731Zm-1.96,8.177h1.8c1.992,0,3.14-1.24,3.14-3.425,0-2.152-1.167-3.406-3.14-3.406h-1.8Z",
    transform: "translate(-35.671 -8.262)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_765",
    "data-name": "Path 765",
    d: "M41.681,13.837c0-2.316,1.293-3.729,3.392-3.729s3.387,1.413,3.387,3.729-1.288,3.737-3.387,3.737S41.681,16.167,41.681,13.837Zm5.32,0c0-1.558-.7-2.469-1.928-2.469s-1.927.911-1.927,2.469.693,2.476,1.927,2.476S47,15.4,47,13.837Z",
    transform: "translate(-32.088 -7.441)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_766",
    "data-name": "Path 766",
    d: "M54.556,17.382H53.084L51.6,12.088h-.113l-1.478,5.294H48.551L46.569,10.2h1.44L49.3,15.679H49.4L50.88,10.2h1.36l1.478,5.484h.112L55.112,10.2H56.53Z",
    transform: "translate(-29.174 -7.389)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_767",
    "data-name": "Path 767",
    d: "M53.854,10.247h1.365v1.141h.105a2.153,2.153,0,0,1,2.145-1.28c1.6,0,2.488.962,2.488,2.674v4.653H58.539v-4.3c0-1.156-.5-1.73-1.551-1.73a1.649,1.649,0,0,0-1.716,1.821v4.206H53.854Z",
    transform: "translate(-24.832 -7.441)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_768",
    "data-name": "Path 768",
    d: "M59.094,8.437h1.417V18.43H59.094Z",
    transform: "translate(-21.708 -8.437)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_769",
    "data-name": "Path 769",
    d: "M61.218,13.837c0-2.316,1.293-3.729,3.392-3.729S68,11.521,68,13.837s-1.288,3.737-3.387,3.737S61.218,16.167,61.218,13.837Zm5.32,0c0-1.558-.7-2.469-1.928-2.469s-1.927.911-1.927,2.469.693,2.476,1.927,2.476S66.538,15.4,66.538,13.837Z",
    transform: "translate(-20.442 -7.441)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_770",
    "data-name": "Path 770",
    d: "M66.4,15.4c0-1.293.962-2.04,2.674-2.145l1.946-.112v-.621c0-.758-.5-1.188-1.47-1.188-.793,0-1.341.29-1.5.8H66.679c.145-1.234,1.306-2.025,2.937-2.025,1.8,0,2.817.9,2.817,2.415v4.911H71.068v-1.01h-.113A2.414,2.414,0,0,1,68.8,17.552,2.172,2.172,0,0,1,66.4,15.4Zm4.619-.613v-.6l-1.754.112c-.99.067-1.44.4-1.44,1.037s.562,1.023,1.333,1.023A1.694,1.694,0,0,0,71.02,14.788Z",
    transform: "translate(-17.352 -7.441)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_771",
    "data-name": "Path 771",
    d: "M71.348,14.833c0-2.271,1.168-3.709,2.983-3.709a2.369,2.369,0,0,1,2.2,1.261h.107V8.437H78.06V18.43H76.7V17.294h-.113a2.492,2.492,0,0,1-2.257,1.255C72.5,18.549,71.348,17.11,71.348,14.833Zm1.465,0c0,1.524.718,2.442,1.92,2.442s1.935-.931,1.935-2.436S75.921,12.4,74.733,12.4,72.813,13.321,72.813,14.833Z",
    transform: "translate(-14.403 -8.437)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_772",
    "data-name": "Path 772",
    d: "M79.23,13.837c0-2.316,1.294-3.729,3.392-3.729s3.387,1.413,3.387,3.729-1.288,3.737-3.387,3.737S79.23,16.167,79.23,13.837Zm5.32,0c0-1.558-.7-2.469-1.928-2.469s-1.927.911-1.927,2.469.694,2.476,1.927,2.476S84.55,15.4,84.55,13.837Z",
    transform: "translate(-9.704 -7.441)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_773",
    "data-name": "Path 773",
    d: "M84.669,10.247h1.366v1.141h.105a2.153,2.153,0,0,1,2.145-1.28c1.6,0,2.488.962,2.488,2.674v4.653H89.355v-4.3c0-1.156-.5-1.73-1.551-1.73a1.649,1.649,0,0,0-1.716,1.821v4.206H84.669Z",
    transform: "translate(-6.462 -7.441)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_774",
    "data-name": "Path 774",
    d: "M94.471,9.074V10.9h1.558v1.2H94.471v3.7c0,.753.31,1.084,1.017,1.084a4.8,4.8,0,0,0,.541-.034v1.181a4.568,4.568,0,0,1-.773.073c-1.577,0-2.2-.555-2.2-1.941V12.091H91.911V10.9h1.141V9.074Z",
    transform: "translate(-2.144 -8.057)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_775",
    "data-name": "Path 775",
    d: "M95.705,8.437h1.4V12.4h.113a2.213,2.213,0,0,1,2.191-1.286,2.368,2.368,0,0,1,2.476,2.68v4.64h-1.421V14.14c0-1.148-.535-1.73-1.537-1.73a1.68,1.68,0,0,0-1.81,1.823v4.2H95.705Z",
    transform: "translate(0.117 -8.437)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_776",
    "data-name": "Path 776",
    d: "M107.164,15.493a2.917,2.917,0,0,1-3.114,2.08c-2.059,0-3.32-1.413-3.32-3.711s1.288-3.754,3.314-3.754c2,0,3.207,1.366,3.207,3.623v.495h-5.076v.08a1.9,1.9,0,0,0,1.914,2.059,1.725,1.725,0,0,0,1.711-.871Zm-4.99-2.316h3.631a1.736,1.736,0,0,0-1.77-1.863A1.839,1.839,0,0,0,102.174,13.177Z",
    transform: "translate(3.113 -7.441)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleEn);
export default __webpack_public_path__ + "static/media/apple-en.bdd545d17d108939b0090612087996da.svg";
export { ForwardRef as ReactComponent };